<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售计划新增单（公司/营销单元）</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button v-if="mode == 'edit'" @click="$router.go(-1)">返回</form-button>
        <!-- 页面新建状态 -->
        <template v-if="$_has(['WLY004', 'WLYALL']) && !conditions.plan_order">
          <form-button type="primary" @click="changeStatus('SAVE')">保存</form-button>
          <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
        </template>

        <template v-if="conditions.plan_order">
          <template v-if="$_has(['WLY002', 'WLY004', 'WLYALL'])">
            <template v-if="conditions.porder_status === 'E004'">
              <form-button @click="copyOrder">复制</form-button>
            </template>
            <template v-else>
              <form-button v-if="!showEdit" @click="showEdit = true">修改</form-button>
              <form-button @click="copyOrder">复制</form-button>
            </template>
          </template>
        </template>

        <template v-if="showEdit">
          <form-button @click="showEdit = false">显示</form-button>
          <template v-if="$_has(['WLY004', 'WLYALL'])">
            <template v-if="conditions.porder_status === 'E001'">
              <form-button type="primary" @click="changeStatus('SAVE')">保存</form-button>
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
            </template>
            <template v-if="conditions.porder_status === 'E002'">
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
              <form-button @click="changeStatus('CANCEL')">取消</form-button>
            </template>
            <template v-if="conditions.porder_status === 'E004'">
              <form-button>复制</form-button>
            </template>
          </template>

          <template v-if="conditions.porder_status === 'E003' && conditions.cancel">
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
        </template>
      </div>
      <el-form
        ref="form"
        :show-message="false"
        inline
        size="mini"
        :disabled="isEdit"
        label-width="100px"
        :model="conditions"
        :rules="rules"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="销售计划单号">
              <el-input v-model="conditions.plan_order" disabled placeholder="" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据类型">
              <el-input value="销售计划新增单（公司/营销单元）" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="销售计划编号">
              <el-input v-model="conditions.plan_number" disabled placeholder="自动生成" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="sal_center" class="line-16" label="">
              <template #label>
                公司/营销单元
              </template>
              <el-select v-model="conditions.sal_center" placeholder="" clearable filterable>
                <el-option
                  v-for="item in saleList"
                  :key="item.SOBID"
                  :value="item.SOBID"
                  :label="item.MC_SHORT"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="wlybrand" label="存货分类">
              <el-select v-model="conditions.wlybrand" placeholder="" filterable>
                <el-option
                  v-for="item in selectDataOptions['A0019']"
                  :key="item.value"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="gjahr" label="年度">
              <el-date-picker
                v-model="conditions.gjahr"
                type="year"
                format="yyyy"
                value-format="yyyy"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="24">
            <common-title title="计划量" />
            <el-row>
              <el-col>
                <el-form-item label="初始计划量(吨)" class="line-16" prop="initplan_qty">
                  <el-input v-model.number="conditions.initplan_qty" placeholder="" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="24">
            <common-title title="计划额（参考）" />
            <el-row>
              <el-col>
                <el-form-item label="初始计划额(万元)" class="line-16" prop="initplan_amt">
                  <el-input v-model.number="conditions.initplan_amt" placeholder="" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="24">
            <el-form-item label="备注">
              <el-input v-model="conditions.remark" type="textarea" rows="4" placeholder="" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { getSalePlanCompnayByNumber, getSalePlanCompnayCreate } from '@/api/sap/sale-plan'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'

export default {
  data() {
    const rules = {
      gjahr: [{ required: true, message: '请选择年度', trigger: 'blur' }],
      wlybrand: [{ required: true, message: '请选择存货分类', trigger: 'change' }],
      sal_center: [{ required: true, message: '请选择公司/营销单元', trigger: 'change' }],
      initplan_qty: [{ required: true, message: '请输入初始计划量', trigger: 'blur' }],
      // initplan_amt: [{ required: true, message: '请输入初始计划额', trigger: 'blur' }]
    }
    return {
      rules,
      mode: 'add',
      showEdit: false,
      loading: false,
      errorList: [],
      saleList: [],
      conditions: {
        plan_order: '',
        plan_number: '',
        gjahr: '',
        wlybrand: '',
        sal_center: '',
        order_type: 'ZP03',
        initplan_qty: '',
        initplan_amt: '',
        remark: '',
        porder_status: 'E001'
      },
      gridOptions: {
        data: [],
        columns: [
          { field: 'operationer', title: '操作员' },
          { field: 'oper_name', title: '操作员姓名' },
          { field: 'oper_status_text', title: '操作状态' },
          { field: 'changin_date', title: '变更日期' },
          { field: 'changin_time', title: '变更时间' }
        ]
      },
      selectDataOptions: {}
    }
  },
  computed: {
    isEdit() {
      if (this.conditions.plan_order) {
        return !this.showEdit
      } else {
        return false
      }
    }
  },
  created() {
    // 存货分类
    this.getSelectDictDataOrigin('A0019')
    apiGetOrgOrBase('', 0).then(res => {
      res.DATA.forEach(item => {
        item.MC_SHORT += ' | ' + item.SOBID
      })
      this.saleList = res.DATA
    })
    const params = this.$route.params
    // 编辑单
    if (this.$route.query.order && !Reflect.ownKeys(params).length) {
      this.mode = 'edit'
      this.salePlanCountFindById()
    } else if (Reflect.ownKeys(params).length) {
      Object.assign(this.conditions, params)
    }
  },
  methods: {
    // 保存 提交 取消
    changeStatus(mode) {
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          const params = {
            iv_mode: mode,
            user_bp: this.$store.getters.role.USER_BP,
            ls_header: this.conditions
          }
          this.errorList = []
          const res = await getSalePlanCompnayCreate(params)
          if (res?.msgtype !== 'S') {
            this.errorList.push(res.message)
            return
          }
          this.$message.success(res.message)
          this.showEdit = false
          this.gridOptions.data = res.status
          Object.assign(this.conditions, res.data)
          this.conditions.cancel = res.cancel
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    copyOrder() {
      const resetFields = [
        'plan_order',
        'plan_number',
        'futur_adjqty',
        'futur_adjamt',
        'change_name',
        'uzeit',
        'timestamp',
        'mdate',
        'mtime',
        'mname',
        'mtimestamp',
        'porder_status'
      ]
      if (this.mode === 'add') {
        resetFields.forEach(key => {
          if (key === 'porder_status') {
            this.conditions[key] = 'E001'
          } else {
            this.conditions[key] = ''
          }
        })
        this.gridOptions.data = []
        this.showEdit = false
      } else {
        const params = { ...this.conditions }
        resetFields.forEach(key => {
          if (key === 'porder_status') {
            params[key] = 'E001'
          } else {
            params[key] = ''
          }
        })
        this.$router.replace({
          name: '10.05 销售计划新增单(公司/营销单元)',
          params
        })
      }
    },
    async salePlanCountFindById() {
      const { data } = await getSalePlanCompnayByNumber({ plan_order: this.$route.query.order })
      Object.assign(this.conditions, data.ls_head || {})
      this.conditions.cancel = data.cancel
      this.gridOptions.data = data.lt_chg_history || []
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          if (dictcode === 'A0019') {
            response.data.Rows.forEach(item => {
              item.name += '  |  ' + item.value
            })
          }
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanCompany.vue